(function () {
  'use strict';

  // Respect reduced-motion + require IntersectionObserver
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  // Areas whose images should NOT blur (UI chrome + components with their
  // own image animation: header/footer/nav/cart, the hero carousel, and the
  // collection card carousel).
  var EXCLUDE = [
    '.header-wrapper', 'header', '.header',
    '.yc-mnav', '.yc-menu-overlay', '.yc-mega',
    'cart-drawer', '.cart-drawer', '.cart-notification',
    '.yc-newsfoot', 'footer',
    '.yc-hero',         // has its own load blur-up
    '.yc-card-track',   // collection carousel has its own crossfade
    '.yc-pdp__viewport' // product slider has its own crossfade
  ].join(', ');

  var SKIP_RE = /icon|logo|payment|badge|swatch|avatar/i;

  function eligible(img) {
    if (img.closest(EXCLUDE)) return false;
    if (SKIP_RE.test(img.className + ' ' + (img.getAttribute('src') || ''))) return false;
    // skip tiny / icon-sized images
    var w = parseInt(img.getAttribute('width'), 10);
    if (w && w < 100) return false;
    var rect = img.getBoundingClientRect();
    if (rect.width && rect.width < 90) return false;
    return true;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('yc-blur--in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });

  function tag(img) {
    if (img.classList.contains('yc-blur') || !eligible(img)) return;
    img.classList.add('yc-blur');
    io.observe(img);
  }

  function scan(root) {
    (root || document).querySelectorAll('img').forEach(tag);
  }

  scan(document);

  // catch images added later (AJAX cart, quick views, theme editor, etc.)
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'IMG') tag(n);
          else if (n.querySelectorAll) scan(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
